<template>
  <AppPreloader v-if="loading" />
  <div v-else>
    <VacancyContainer
      v-if="vId && cId"
      :id="vId"
      :company-id="cId"
      @ready="handleVacancyContainerReady"
    >
      <AppIosMessage
        v-if="isIOS"
        :vacancy-id="vId"
        :candidate="candidate"
        :redirect-url="currentUrl"
      />
    </VacancyContainer>
  </div>
</template>

<script>
import AppPreloader from '@/components/AppPreloader.vue';
import AppIosMessage from '@/components/AppIosMessage.vue';
import { isIOS } from '@/functions';
import { mapState } from 'vuex';
import VacancyContainer from '@/components/Vacancy/VacancyContainer.vue';


export default {
  name: 'IosStub',
  components: { VacancyContainer, AppIosMessage, AppPreloader },
  props: {
    hashId: {
      type: String,
      required: false,
      default: null,
    },
    vacancyId: {
      type: Number,
      required: false,
      default: null,
    },
  },
  metaInfo() {
    return {
      title: this.pageTitle,
    };
  },
  data() {
    return {
      loading: true,
      pageTitle: null,
    };
  },
  computed: {
    ...mapState('candidate', {
      candidate: state => state?.data?.candidate,
    }),
    ...mapState('company', ['company', 'vacancies']),
    ...mapState('vacancy', {
      vacancy: state => state?.vacancy?.data,
    }),
    vId() {
      if (!this.vacancy?.id && !this.candidateVacancy?.id) {
        return null;
      }

      return this.vacancy?.id || this.candidateVacancy?.id;
    },
    cId() {
      if (!this.vacancy?.companyId && !this.candidateVacancy?.companyId) {
        return null;
      }

      return this.vacancy?.companyId || this.candidateVacancy?.companyId;
    },
    currentUrl() {
      const route = this.$router.resolve({ /* your route here */ });
      return new URL(route.href, window.location.origin).href;
    },
  },
  async mounted() {
    if (!this.hashId && !this.vacancy) {
      await this.redirectToNotFound();
    }

    if (!this.isIOS()) {
      if (this.hashId) {
        await this.$router.push({
          name: 'candidatePersonalLink',
          params: {
            hashId: this.hashId,
          },
        });

        return;
      }

      if (this.vacancyId) {
        await this.$router.push({
          name: 'vacancyShort',
          params: {
            vacancyId: this.vacancyId,
          },
        });
        return;
      }
    }

    if (this.hashId) {
      await this.fetchCandidate();
    }

    if (this.vacancyId) {
      await this.fetchVacancy();
    }

    this.$nextTick(() => {
      this.loading = false;
    });
  },
  methods: {
    isIOS() {
      // TODO: Убрать || true после теста
      return isIOS();
    },
    // eslint-disable-next-line consistent-return
    async fetchCandidate() {
      try {
        await this.$store.dispatch('candidate/loginByHashId', {
          hashId: this.hashId,
          vacancyId: this.vacancyId,
        });
        await this.$store.dispatch('candidate/fetchData', { vacancyId: this.vacancyId });
      } catch (e) {
        if (e.name === 'ApiError') {
          if (e.code === 404) {
            await this.redirectToNotFound();
          }

          if (e.code === 410) {
            await this.$router.push({
              name: 'vacancyIosStubLink',
              params: {
                vacancyId: e.data.vacancyId,
              },
            });
            await this.$toast.error(e.message, { timeout: 5000 });
          }
        }
        throw e;
      }
    },
    // eslint-disable-next-line consistent-return
    async fetchVacancy() {
      try {
        await this.$store.dispatch('vacancy/fetchVacancy', this.vacancyId);
      } catch (e) {
        if (e.name === 'ApiError') {
          if (e.code === 404) {
            await this.redirectToNotFound();
          }
        }

        throw e;
      }
    },
    async redirectToNotFound() {
      console.log('REDIRECT TO 404!');
      return;
      await this.$router.push({ name: '404' });
    },
    handleVacancyContainerReady({ vacancy }) {
      this.pageTitle = `${this.$t('pageTitle')} ${vacancy.title}`;
    },
  },
};
</script>

<style scoped lang="scss">

</style>

<i18n locale="en" lang="yaml">
pageTitle: Online interview for the job
</i18n>

<i18n locale="ru" lang="yaml">
pageTitle: Онлайн-собеседование на вакансию
</i18n>
